module.exports = __webpack_public_path__ + "static/image/font/pc/bmkiranghaerang-4@3x.ver2_0_2.jpg?73531552";